<script lang="ts">
  import AudioRecordButton from "../../../utils/AudioRecordButton.svelte";
  import { get_host } from "../../../settings";
  import VerticalAlign from "../../../materialize/grid/VerticalAlign.svelte";
  import Row from "../../../materialize/grid/Row.svelte";
  import Column from "../../../materialize/grid/Column.svelte";
  import Center from "../../../materialize/grid/Center.svelte";
</script>

<Row>
  <Column small={12}>
    <Center>
      <AudioRecordButton on:completed />
    </Center>
  </Column>
</Row>
